VjsAdmin.MarketingPages = (function () {
    const $table = $('#marketing-links-table');

    const init = function () {
        initTable();
    };

    const initTable = function () {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#marketing-links-table',

            formatNoMatches() {
                return 'No Pages Found';
            },

            idField: 'id',
            sortName: 'id',
            sortOrder: 'DESC',
            search_product: '',
            search_platform: '',

            url: Slim.Router.pathFor('marketing.pages.json'),

            onPreBody(data) {
                VjsTable.tableDefaults().onPreBody.call(this, data);

                const thisTable = this;

                $('#search-product').off();
                $('#search-product').on('change', () => {
                    thisTable.search_product = $('#search-product option:selected').val();
                    thisTable.updateUrl();
                    $('#marketing-links-table').bootstrapTable('refresh');
                });

                if (typeof this.default_product === 'undefined') {
                    this.default_product = this.search_product;
                }
                this.search_product = $.urlParam('search_product') != null ? $.urlParam('search_product') : this.default_product;

                $(`#search-manager option[value="${decodeURIComponent(this.search_product)}"]`).attr('selected', true);

                $('#search-platform').off();
                $('#search-platform').on('change', () => {
                    thisTable.search_platform = $('#search-platform option:selected').val();
                    thisTable.updateUrl();
                    $('#marketing-links-table').bootstrapTable('refresh');
                });

                if (typeof this.default_platform === 'undefined') {
                    this.default_platform = this.search_platform;
                }
                this.default_platform = $.urlParam('default_platform') != null ? $.urlParam('default_platform') : this.default_platform;

                $(`#search-purchased-for option[value="${decodeURIComponent(this.default_platform)}"]`).attr('selected', true);
            },

            updateUrl() {
                const queryParams = {};

                if (this.search_product !== this.default_product) {
                    queryParams.search_product = this.search_product;
                }

                if (this.search_platform !== this.default_platform) {
                    queryParams.search_platform = this.search_platform;
                }

                VjsTable.tableDefaults().updateUrl.call(this, queryParams);
            },
            queryParams(params) {
                const myParams = VjsTable.tableDefaults().queryParams.call(this, params);

                myParams.platform = this.search_platform;
                myParams.product = this.search_product;
                return myParams;
            },
            columns: [
                {
                    title: 'ID',
                    field: 'id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Name',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'URL',
                    field: 'url',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: '',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    const row = VjsAdmin.convertDateRow(result, 'MM/DD/YYYY');
                    row.is_active = row.active;

                    row.actions = `<a href="/marketing/pages/${row.id}/edit/" class="btn btn-hollow-blue edit">Edit</a>`;
                });
                return formattedResult;
            },
        });
    };

    return {
        init,
    };
}());
